import React, { useEffect, useState } from 'react';
import $i18n from '../../../../i18n';
// import { Icon } from '@alifd/next';
import { history } from 'ice';
import { Drawer, Icon, Modal } from '@b-design/fusion';
import Button from '@/components/Button';
import { stepConfig } from './stepConfig.js';
// import arrow from '../../../../assets/overview/arrow.svg';
import store from '@/store';
import Requests from '@/services/request';
import { getQueryStringArgs } from '@/utils/url-parse';
import './index.less';
import NameIcon from '@/components/NameIcon';

interface Props {
  changeSteps: (val: any) => void;
}
const StepC: React.FC<Props> = (props) => {
  const [spaceRoleState] = store.useModel('spaceRole');
  const { invitationCode, companyId, approveId, spaceId = '' } = getQueryStringArgs();
  const [visible, setVisible] = useState(false);
  const [detail, setDetail] = useState<any>({});
  const [companyDate, setCompanyDate] = useState({});

  const showDrawer = () => {
    setVisible(true);
    if (companyId) {
      // 获取公司信息
      Requests.get('/rest/intercnn/company/query', {
        companyIds: companyId,
      }).then((data) => {
        if (data) {
          if (data.list[0]?.customerPhone !== '-') {
            if (data.list[0]?.customerPhone?.split('-')[0]) {
              data.list[0].customerPhone = `+${data.list[0]?.customerPhone?.split('-')[0]} ${data.list[0]?.customerPhone?.split('-')[1]
                }`;
            } else {
              data.list[0].customerPhone = `${data.list[0]?.customerPhone?.split('-')[1]}`;
            }
          } else {
            delete data.list[0]?.customerPhone;
          }
          setCompanyDate(data.list);
        }
      });
    }
  };

  // 审批通过后跳转overview
  useEffect(() => {
    if (!spaceId) {
      return;
    };
    Requests.get('/rest/intercnn/space/query', { spaceIds: spaceId }).then((res) => {
      if (res) {
        const data0 = { ...res.list[0], roleList: res.list[0]?.role?.split(',') || [] }
        setDetail(data0);
        if (data0?.status === 'ACTIVE') {
          history?.push(`/overview?spaceId=${data0?.spaceId || ''}`);
        }
      }
    });
  }, []);

  // 返回上一步
  const preSteps = () => {
    history?.push(
      `/settlein?invitationCode=${invitationCode}&spaceId=${spaceId}&companyId=${companyId}&approveId=${approveId}&step=1`,
    );
  };

  const onClose = () => {
    setVisible(false);
  };

  const submitWithdraw = async () => {
    const res = await Requests.post('/rest/intercnn/approve/process', {
      approveId: approveId,
      approveAction: 'WITHDRAW',
      approveOpinion: 'WITHDRAW',
    });
      if (res) {
        history?.push(
          `/settlein?invitationCode=${invitationCode}&spaceId=${spaceId}&companyId=${companyId}&approveId=${approveId}&step=0`,
        );
      }
  };

  const withdrawSpace = () => {
    Modal.confirm({
      title: $i18n.get({
        id: 'aopf.pages.miniapp.version.info.process.Withdraw',
        dm: '回退',
      }),
      content: $i18n.get({
        id: 'aopf.pages.miniapp.version.info.space.Withdraw.Content',
        dm: '是否确实要撤消空间审批',
      }),
      footerActions: ['cancel', 'ok'],
      onOk: submitWithdraw,
      style: { width: '340px' },
    });
  };

  return (
    <div className="spaceC-container">
      <div className="spaceC-content">
        <div className="spaceC-title">
          {$i18n.get({
            id: 'aopf.pages.miniapp.settleIn.application',
            dm: '我们将审查您的申请',
          })}
        </div>
        <div className="spaceC-descript">
          <span>
            {$i18n.get({
              id: 'aopf.pages.miniapp.settleIn.wait',
              dm: '请耐心等待。审查通常需要',
            })}
          </span>
          <span className="title-num" >1-2</span>
          <span>
            {$i18n.get({
              id: 'aopf.pages.miniapp.settleIn.business.days',
              dm: '工作日。只要我们有更新，我们会通知您的。',
            })}
          </span>
        </div>
        <div className="spaceC-eyes" onClick={showDrawer}>
          <Icon type="view--filled" />
          <span className="eyes-text" >
            {$i18n.get({
              id: 'aopf.pages.miniapp.settleIn.View.Application.Info',
              dm: '查看应用程序信息',
            })}
          </span>
        </div>
        <div className="spaceC-release">
          {$i18n.get({
            id: 'aopf.pages.miniapp.settleIn.release.miniapp',
            dm: '如何发布小程序',
          })}
        </div>
        <div className="spaceC-steps">
          {stepConfig.map((item) => (
            <div className="footerItem" key={item.key}>
              <div>
                <img
                  // src={arrow}
                  src={"https://gw.alicdn.com/imgextra/i4/O1CN015Zrqfr1hrePkYEYLw_!!6000000004331-2-tps-60-60.png"}
                  className={
                    item.key === '01'
                      ? 'img-next-no'
                      : item.key === '06' || item.key === '07'
                        ? 'img-left'
                        : 'img-next'
                  }
                  alt=""
                />
                <img
                  // src={spaceRoleState.roleList?.includes('ADMIN') ? item.imgUrlAdmin : item.imgUrlDeveloper}
                  src={item.imgUrlAdmin}
                  alt=""
                  className="item-img"
                  style={{ ...item.style, opacity: ['01', '02'].includes(item.key) && !spaceRoleState?.roleList?.includes('ADMIN') ? 0.4 : 1 }}
                />
              </div>
              <div className={item.key === '07' ? 'footerDescLeft' : 'footerDesc'}>
                {item?.title}
              </div>
            </div>
          ))}
        </div>
        <div onClick={preSteps} className="btn-pre">
          {$i18n.get({
            id: 'aopf.pages.miniapp.settleIn.Previous.Step',
            dm: '上一步',
          })}
        </div>
        <Drawer
          data-size="large"
          title={$i18n.get({
            id: 'aopf.pages.miniapp.settleIn.Space.Information',
            dm: '空间信息',
          })}
          placement="right"
          onClose={onClose}
          visible={visible}
        >
          <div className="space-drawer-container">
            <div className="drawer-info">
              <div className="info-item">
                <div className="item-title">
                  <span className="drawer-required">*</span>{' '}
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.settleIn.Space.Name',
                    dm: '空间名称',
                  })}
                </div>
                <div className="item-value">{detail?.name}</div>
              </div>

              <div className="info-item">
                <div className="item-title">
                  <span className="drawer-required">&nbsp;&nbsp;</span>
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.settleIn.Space.Icon',
                    dm: '空间logo',
                  })}
                </div>
                {detail?.iconPublicUrl ? (
                  <img className="info-img" src={detail?.iconPublicUrl} />
                ) : (
                  <NameIcon name={detail?.name} />
                )}
              </div>

              <div className="info-item">
                <div className="item-title">
                  <span className="drawer-required">*</span>{' '}
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.settleIn.Company.Name',
                    dm: '公司名称',
                  })}
                </div>
                <div className="item-value">{companyDate[0]?.name}</div>
              </div>

              <div className="info-item">
                <div className="item-title">
                  <span className="drawer-required">*</span>{' '}
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.settleIn.Business.Address',
                    dm: '公司地址',
                  })}
                </div>
                <div className="item-value">{companyDate[0]?.address}</div>
              </div>

              <div className="info-item">
                <div className="item-title">
                  <span className="drawer-required">*</span>{' '}
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.settleIn.Business.Representative',
                    dm: '公司代表',
                  })}
                </div>
                <div className="item-value">{companyDate[0]?.principal}</div>
              </div>

              <div className="info-item">
                <div className="item-title">
                  &nbsp;
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.settleIn.Website',
                    dm: '网站',
                  })}
                </div>
                <div className="item-value">{companyDate[0]?.webPage}</div>
              </div>

              <div className="info-item">
                <div className="item-title">
                  &nbsp;
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.settleIn.Contact.Number',
                    dm: '联系电话',
                  })}
                </div>
                <div className="item-value">{companyDate[0]?.customerPhone}</div>
              </div>

              <div className="info-item">
                <div className="item-title">
                  &nbsp;
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.settleIn.Email.Address',
                    dm: '电子邮件地址',
                  })}
                </div>
                <div className="item-value">{companyDate[0]?.customerEmail}</div>
              </div>
            </div>
            <div>
              <Button
                type="primary"
                onClick={onClose}
                className="drawer-btn"
              >
                {$i18n.get({
                  id: 'aopf.pages.miniapp.settleIn.Close',
                  dm: '关闭',
                })}
              </Button>
              <Button
                // type="primary"
                onClick={withdrawSpace}
                className="drawer-btn"
              >
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.info.process.Withdraw',
                  dm: '回退',
                })}
              </Button>
            </div>
          </div>
        </Drawer>
      </div>
    </div>
  );
};

export default StepC;
